import { render, staticRenderFns } from "./DialogFaturas.vue?vue&type=template&id=48cadf72&lang=pug"
import script from "./DialogFaturas.vue?vue&type=script&lang=js"
export * from "./DialogFaturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports